<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>settings_accessibility</md-icon>
        </div>
        <h4 class="title">Partners</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              v-if="$allowed('supplier.manage')"
              class="md-icon-button md-dense md-primary md-round"
              @click="newSupplier"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Partner</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="suppliers" @md-selected="viewSupplier">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Company">
              <a href="#" @click.prevent="viewSupplier(item)">{{
                item.company
              }}</a>
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                v-if="$allowed('supplier.manage')"
                class="md-just-icon md-simple md-danger "
                @click="deleteSupplier(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewSupplier(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            v-if="$allowed('supplier.manage')"
            md-label="Supply..."
            md-description="Add a Partner"
          >
            <md-button class="md-primary md-raised" @click.stop="newSupplier"
              >Add Partner</md-button
            >
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["suppliers"],

  methods: {
    newSupplier() {
      this.$emit("addSupplier");
    },

    viewSupplier(supplier) {
      this.$emit("viewSupplier", supplier);
    },

    deleteSupplier(supplier) {
      this.$emit("deleteSupplier", supplier);
    }
  }
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
